(() => {
  'use strict';
  const initialize = (root) => {
    if (root.dataset.archiveEnhanced === 'true') return;
    root.dataset.archiveEnhanced = 'true';
    const gallery = root.querySelector('[data-archive-gallery]');
    if (gallery) {
      const controls = gallery.querySelector('[data-archive-gallery-controls]');
      const views = [...gallery.querySelectorAll('[data-archive-view]')];
      if (controls && views.length > 1) {
        gallery.classList.add('is-enhanced');
        controls.hidden = false;
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-archive-view-select]');
          if (!button || !controls.contains(button)) return;
          const viewName = button.dataset.archiveViewSelect;
          const index = views.findIndex((view) => view.dataset.archiveView === viewName);
          if (index < 0) return;
          views.forEach((view, viewIndex) => view.classList.toggle('is-active', index === viewIndex));
          controls.querySelectorAll('[data-archive-view-select]').forEach((control) => control.setAttribute('aria-pressed', String(control === button)));
          const position = gallery.querySelector('[data-archive-gallery-position]');
          if (position) position.textContent = `${index + 1} / ${views.length}`;
        });
      }
    }

    const selector = root.querySelector('[data-product-variant]');
    const sizeGroup = root.querySelector('[data-archive-sizes]');
    if (!selector || !sizeGroup || root.dataset.productEnhanced !== 'true') return;
    const buttons = [...sizeGroup.querySelectorAll('[data-archive-variant]')];
    if (!buttons.length || buttons.some((button) => !button.textContent.trim())) return;
    const colors = new Set(buttons.map((button) => button.dataset.archiveColor || ''));
    const signatures = buttons.map((button) => `${button.dataset.archiveColor || ''}:${button.textContent.trim()}`);
    if (new Set(signatures).size !== signatures.length) return;

    const update = () => {
      const option = selector.selectedOptions[0];
      if (!option) return;
      buttons.forEach((button) => {
        const matchingOption = [...selector.options].find((item) => item.value === button.dataset.archiveVariant);
        const selected = button.dataset.archiveVariant === option.value;
        button.hidden = colors.size > 1 && button.dataset.archiveColor !== option.dataset.color;
        button.setAttribute('aria-pressed', String(selected));
        button.disabled = matchingOption?.dataset.available !== 'true';
        button.setAttribute('aria-disabled', String(button.disabled));
      });
      const colorLabel = root.querySelector('[data-product-color]');
      if (colorLabel && root.dataset.archiveColorLabel) colorLabel.textContent = root.dataset.archiveColorLabel;
    };
    sizeGroup.hidden = false;
    const nativeField = root.querySelector('[data-archive-native-variant]');
    if (nativeField && colors.size <= 1) {
      nativeField.hidden = true;
      root.classList.add('is-archive-size-enhanced');
    }
    sizeGroup.addEventListener('click', (event) => {
      const button = event.target.closest('[data-archive-variant]');
      if (!button || !sizeGroup.contains(button) || button.disabled) return;
      const option = [...selector.options].find((item) => item.value === button.dataset.archiveVariant);
      if (!option) return;
      selector.value = option.value;
      selector.dispatchEvent(new Event('change', { bubbles: true }));
    });
    selector.addEventListener('change', update);
    update();
  };
  const init = (scope = document) => {
    if (scope.matches?.('.product-page--archive')) initialize(scope);
    scope.querySelectorAll('.product-page--archive').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
